// localStorage wrapper namespaced under "e16:".

const NS = "e16:";

// Current logged-in user id — used to isolate per-user UI prefs on a
// SHARED browser so one user's Theme Lab choices never leak to another.
// Falls back to "guest" before the Frappe session boots (e.g. login page).
export function currentUser() {
	try {
		if (window.frappe && frappe.session && frappe.session.user) {
			return frappe.session.user;
		}
	} catch (e) {}
	return "guest";
}

// Build a localStorage key scoped to the active user, e.g.
//   userKey("ux") -> "e16:u:Administrator:ux"
export function userKey(key) {
	return `${NS}u:${currentUser()}:${key}`;
}

export const storage = {
	get(key, fallback = null) {
		try {
			const raw = window.localStorage.getItem(NS + key);
			return raw === null ? fallback : JSON.parse(raw);
		} catch (e) { return fallback; }
	},
	set(key, value) {
		try { window.localStorage.setItem(NS + key, JSON.stringify(value)); }
		catch (e) {}
	},
	remove(key) {
		try { window.localStorage.removeItem(NS + key); } catch (e) {}
	},
};
